<div class="flex flex-col gap-1.5" [class]="containerClass()">
  <label class="checklist-task-label label" [attr.for]="id()">
    {{ label() }}
  </label>

  <div
    class="rounded-xl border border-primary bg-quarternary px-4 py-3 text-sm leading-6 text-tertiary"
    [attr.id]="id()"
    role="note"
    aria-live="polite">
    {{ message() }}
  </div>
</div>
